import React from 'react'

const Shimmer = () => {
  return (
    <div className='w-[200px] h-[300px] bg-gradient-to-br from-gray-800 to-red-800 rounded-md animate-pulse'></div>
  )
}

export default Shimmer